/* eslint-disable react/prop-types */

import * as React from 'react';
import styled from 'styled-components';

import { withRouter } from 'next/router';

const RowWrapper = styled.div`
  .ReactVirtualized__Table__row {
    padding: 2px 0;
    .column-container {
      display: flex;
      width: 100%;
      height: 100%;
    }
  }
  .ReactVirtualized__Table__row:hover {
    .column-container {
      background: ${({ theme }) => theme.tableRowHoverBg};
    }
    .btns-area {
      visibility: visible;
      
    }
    img.mainImg {
      visibility: hidden;
    }
  }
`;

const getMarketPair = ([newSymbol, ticker]) => {
  const baseAsset = ticker.ba;
  const quoteAsset = newSymbol.split(baseAsset)[1];
  return `${baseAsset}_${quoteAsset}`;
};

const getTradePageLinkHref = ([newSymbol, ticker]) => {
  const newPair = getMarketPair([newSymbol, ticker]);
  return `/en/trade/pro/${newPair}`;
};

export default withRouter(
  ({
    className,
    columns,
    index,
    key,
    onRowClick,
    onRowDoubleClick,
    onRowMouseOut,
    onRowMouseOver,
    onRowRightClick,
    rowData,
    style,
    id,
    HoverRender
  }) => {
    const a11yProps = {};

    if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
      a11yProps['aria-label'] = 'row';
      a11yProps.tabIndex = 0;

      if (onRowClick) {
        a11yProps.onClick = event => onRowClick({ event, index, rowData });
      }
      if (onRowDoubleClick) {
        a11yProps.onDoubleClick = event => onRowDoubleClick({ event, index, rowData });
      }
      if (onRowMouseOut) {
        a11yProps.onMouseOut = event => onRowMouseOut({ event, index, rowData });
      }
      if (onRowMouseOver) {
        a11yProps.onMouseOver = event => onRowMouseOver({ event, index, rowData });
      }
      if (onRowRightClick) {
        a11yProps.onContextMenu = event => onRowRightClick({ event, index, rowData });
      }
    }

    return (
      <RowWrapper role="row" key={key}>
        <div
          //href={getTradePageLinkHref(rowData)}
          key={key}
          className={className} 
          style={style}
          id={id} {...a11yProps}
        >
          <div className="column-container">
            {columns}
            {HoverRender}
          </div>
        </div>
      </RowWrapper>
    );
  }
);
